import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import BasePopup from '../../components/BasicComponent/BasePopup'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import CardIconsLinkSupport from '../../components/FeatureComponent/CardIconsLinkSupport'
import RegisteredPackageInfo from '../../components/FeatureComponent/RegisteredPackageInfo'
import { useTrafficFineVehicleContext } from '../../context/TrafficFineVehicleContext'
import { number_to_price } from '../../helper/common'
import appUserService from '../../services/appUserService'
import HeaderPartner from '../../components/BasicComponent/HeaderPartner'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import { checkDurationUsageDate } from '../../helper/formatDate'
import './index.scss'
import { useAppUserContext } from '../../context/AppUserContext'

function getBenefits(productOptionalInfo) {
  if (!productOptionalInfo) {
    return []
  }

  if (typeof productOptionalInfo === 'object' && !Array.isArray(productOptionalInfo)) {
    return Array.isArray(productOptionalInfo.benefits) ? productOptionalInfo.benefits : []
  }

  try {
    const parsedInfo = JSON.parse(productOptionalInfo)
    return Array.isArray(parsedInfo?.benefits) ? parsedInfo.benefits : []
  } catch {
    return []
  }
}

export default function TrafficFinePackageInfo() {
  const history = useHistory()
  const location = useLocation()
  const { state } = location
  const { userData } = useAppUserContext()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [isErrorPopupOpen, setIsErrorPopupOpen] = useState(false)
  const [isUpdatingAllowRenew, setIsUpdatingAllowRenew] = useState(false)
  const { getVehicleLists } = useTrafficFineVehicleContext()

  const vehicleActivePackage = state?.vehicleActivePackage
  const notifyInfoId = vehicleActivePackage?.appUserVehicleNotifyInfoId || vehicleActivePackage?.notifyInfoId || vehicleActivePackage?.id
  const allowRenew = Number(vehicleActivePackage?.allowRenew) === 1 ? 1 : 0
  const hasPackage = !!vehicleActivePackage?.productId
  const isLoadingScreenOpen = isUpdatingAllowRenew

  const confirmContent =
    allowRenew === 1
      ? 'Bạn có chắc chắn muốn huỷ gia hạn tự động? Gói của bạn vẫn sẽ hoạt động đến hết thời gian đã thanh toán.'
      : 'Bạn có chắc chắn muốn Gia hạn tự động gói thông báo này không?'

  const handleConfirmUpdateAllowRenew = async () => {
    if (!notifyInfoId || isUpdatingAllowRenew) {
      return
    }

    const nextAllowRenew = allowRenew === 1 ? 0 : 1

    try {
      setIsUpdatingAllowRenew(true)
      setIsConfirmOpen(false)

      const response = await appUserService.AppUserVehicleNotifyInfoPartnerUpdateById(
        {
          username: userData?.phoneNumberWithUsernamePrefix,
          id: Number(notifyInfoId),
          data: { allowRenew: nextAllowRenew }
        },
        false
      )

      if (!response || response.statusCode !== 200) {
        throw response || new Error('UPDATE_NOTIFY_PACKAGE_FAILED')
      }

      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: {
          ...state,
          vehicleActivePackage: {
            ...vehicleActivePackage,
            allowRenew: nextAllowRenew
          }
        }
      })
      void getVehicleLists()
    } catch (error) {
      console.error(error)
      setIsErrorPopupOpen(true)
    } finally {
      setIsUpdatingAllowRenew(false)
    }
  }

  return (
    <LayoutPartner>
      <HeaderPartner title="Quản lý gói thông báo" />

      <div className="TrafficFinePackageInfo">
        {hasPackage ? (
          <RegisteredPackageInfo
            alwaysExpanded={true}
            showTitle={false}
            productName={vehicleActivePackage?.productName}
            priceText={number_to_price(vehicleActivePackage?.productPriceAfterVAT ?? vehicleActivePackage?.productPrice)}
            priceUnit={checkDurationUsageDate(vehicleActivePackage?.usageDate, false)}
            paymentIconUrl={vehicleActivePackage?.paymentIconUrl}
            orderPaymentInfo={vehicleActivePackage?.orderPaymentInfo}
            allowRenew={allowRenew}
            notifyEndDateTime={vehicleActivePackage?.notifyEndDateTime || vehicleActivePackage?.notifyEndDate}
            benefits={getBenefits(vehicleActivePackage?.productOptionalInfo)}
            vehicleType={state?.vehicleType}
            productSize={vehicleActivePackage?.productSize ?? state?.productSize}
            onActionClick={() => {
              if (!notifyInfoId || isUpdatingAllowRenew) {
                return
              }
              setIsConfirmOpen(true)
            }}
          />
        ) : (
          <div className="TrafficFinePackageInfo_empty">Không tìm thấy thông tin gói. Vui lòng quay lại danh sách xe và thử lại.</div>
        )}

        <CardIconsLinkSupport />
      </div>

      <BasePopup
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmUpdateAllowRenew}
        title="Thông báo"
        content={confirmContent}
        closeText="Đóng"
        confirmText="Xác nhận"
      />

      <BasePopup
        open={isErrorPopupOpen}
        onClose={() => setIsErrorPopupOpen(false)}
        title="Cập nhật không thành công"
        content="Đã xảy ra lỗi khi cập nhật gia hạn tự động. Vui lòng thử lại sau."
      />
      <LoadingScreen open={isLoadingScreenOpen} />
    </LayoutPartner>
  )
}
